import React from 'react';
import clsx from 'clsx';

type RadioProps = {
  name: string;
  label?: string;
  value: boolean;
  disabled?: boolean;
  onChange?: (e: boolean) => void;
  radioClassName?: string;
  containerClassName?: string;
  labelClassName?: string;
  icon?: React.ReactElement | React.ReactNode;
};

export const Radio: React.FC<RadioProps> = ({
  name,
  label,
  value,
  disabled = false,
  onChange,
  containerClassName = '',
  radioClassName = '',
  labelClassName = '',
  icon,
}) => {
  return (
    <label
      className="flex items-center hover:cursor-pointer"
      onClick={!disabled ? () => onChange?.(true) : () => {}}
    >
      <span
        className={clsx(
          containerClassName,
          'm-0 min-w-[2rem] min-h-[2rem] w-[2rem] h-[2rem]',
          'flex items-center justify-center relative outline-none border-0',
          'rounded-full appearance-none padding-sm hover:cursor-pointer'
        )}
      >
        <input
          name={name}
          type="radio"
          checked={value}
          onChange={() => 1}
          className={clsx(
            radioClassName,
            'absolute w-full h-full opacity-0 cursor-pointer appearance-none',
            disabled && 'pointer-events-none'
          )}
        />
        <span
          className={clsx(
            'w-full h-full rounded-full border-2 border-darkText flex items-center justify-center transition-colors duration-200',
            !value ? 'bg-white' : 'bg-darkText border-darkText',
            disabled && 'opacity-40'
          )}
        >
          {/* Icon with conditional color */}
          {icon && (
            <span
              className={clsx(
                'flex items-center justify-center',
                !value ? 'text-darkText' : 'text-white'
              )}
            >
              {icon}
            </span>
          )}
        </span>
      </span>
      {label && <span className={clsx(labelClassName)}>{label}</span>}
    </label>
  );
};
